import React from "react";
import "./Contact.css";
import { HiOutlineArrowSmRight } from "react-icons/hi";
import { LiaLinkedinIn } from "react-icons/lia";
import { LiaBehance } from "react-icons/lia";

const Contact = () => {
  return (
    <section className="section3" id="contact">
      <div className="contactcontainer">
        <h1 className="heading1">
          Say Hello<span className="dotcolor contactimage">!</span>
        </h1>
        <div className="emailbutton">
          {" "}
          <a
            href="mailto:anupreetha473@gmail.com"
            rel="noreferrer"
            className="emailtext"
          >
            Email me <HiOutlineArrowSmRight className="rightarrow" />
          </a>
        </div>
        <div className="socialmediahandles">
          <a
            href="https://www.linkedin.com/in/anu-preetha-selvaraj/"
            target="_blank"
            rel="noreferrer"
          >
            <LiaLinkedinIn to="" className="linkedinicon" />
          </a>
          <a
            href="https://www.behance.net/anupreetha"
            target="_blank"
            rel="noreferrer"
          >
            <LiaBehance className="behanceicon" />
          </a>
        </div>
      </div>
    </section>
  );
};

export default Contact;
